import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NewConvoHeader from 'components/App/DesktopView/shared/NewConvoHeader'
import LogConversationForm from 'components/App/DesktopView/CommunicationForms/Reply/LogConversation'
import Scroller from 'components/Scroller'
import ImageLightbox from 'components/ImageLightbox'
import {
  selectDraftIdByTicketId,
  selectMailboxIdForDraftById,
} from 'ducks/drafts2/selectors'
import { doUpsertReplyDraft } from 'ducks/drafts2/operations/doUpsertReplyDraft'
import { doFetchCurrentContact } from 'ducks/crm/contacts/operations/fetching/doFetchCurrentContact'
import { selectCurrentUserId } from 'ducks/currentUser/selectors'
import { selectReassignTicketOnNote } from 'selectors/tickets/assignment'
import { styles } from '../shared/styles'

export default function LogConversationPage() {
  const dispatch = useDispatch()
  const currentUserId = useSelector(selectCurrentUserId)

  const draftId = useSelector(state =>
    selectDraftIdByTicketId(state, 'new', 'note')
  )
  const currentMailboxId = useSelector(state =>
    selectMailboxIdForDraftById(state, draftId)
  )

  const reassignTicketOnNote = useSelector(selectReassignTicketOnNote)

  useEffect(
    () => {
      dispatch(
        doUpsertReplyDraft(draftId, 'note', 'new', null, {
          mailboxId: currentMailboxId,
          assigneeId: reassignTicketOnNote ? currentUserId : null,
        })
      )
      dispatch(doFetchCurrentContact())
    },
    [dispatch, draftId, currentMailboxId, currentUserId, reassignTicketOnNote]
  )

  return (
    <React.Fragment>
      <NewConvoHeader isLogging />
      <div css={styles.composeFormContainer}>
        <Scroller>
          <LogConversationForm ticketId="new" />
        </Scroller>
      </div>
      <ImageLightbox />
    </React.Fragment>
  )
}
